// import React from "react";
// import {
//   FaHandshake,
//   FaCarSide,
//   FaUserTie,
//   FaHeadset,
//   FaCheck,
// } from "react-icons/fa";

// const careers = [
//   {
//     icon: <FaHandshake />,
//     title: "Business Partner",
//     description:
//       "Collaborate with Shivai Tours & Travels and grow your transportation business with our trusted travel network.",
//     points: [
//       "Fleet Expansion Support",
//       "Long-Term Business Growth",
//       "High Revenue Opportunities",
//     ],
//   },
//   {
//     icon: <FaCarSide />,
//     title: "Driver Partner",
//     description:
//       "Join as a driver partner and earn consistently with flexible schedules and reliable trip bookings.",
//     points: [
//       "Valid Driving License Required",
//       "Commercial Vehicle Preferred",
//       "Daily / Weekly Earnings",
//     ],
//   },
//   {
//     icon: <FaUserTie />,
//     title: "Travel Booking Agent",
//     description:
//       "Assist customers with bookings, packages, and travel planning as a Shivai Tours & Travels agent.",
//     points: [
//       "Commission-Based Earnings",
//       "Customer Booking Support",
//       "Office & Remote Opportunities",
//     ],
//   },
//   {
//     icon: <FaHeadset />,
//     title: "Customer Support Executive",
//     description:
//       "Handle customer queries, booking assistance, and operational support professionally.",
//     points: [
//       "Office-Based Role",
//       "Flexible Shift Timings",
//       "Career Growth Opportunities",
//     ],
//   },
// ];

// const CareerSection = () => {
//   return (
//     <>
//     <div className="breadcrumb-bar text-center">
//         <h2 className="text-white">Career </h2>
//       </div>
      
//     <section className="career-section">
//       <div className="container">
//         {/* HEADER */}
//         <div className="career-header">
          

//           <h2>
//             Career At <span>Shivai Travels</span>
//           </h2>

//           <p>
//             Join Shivai Tours & Travels as a Partner, Driver,
//             Booking Agent, or Support Executive and build a
//             successful career with a growing travel company.
//           </p>
//         </div>

//         {/* CARDS */}
//         <div className="career-grid">
//           {careers.map((item, index) => (
//             <div className="career-card" key={index}>
//               <div className="career-icon">{item.icon}</div>

//               <h3>{item.title}</h3>

//               <p>{item.description}</p>

//               <ul>
//                 {item.points.map((point, i) => (
//                   <li key={i}>
//                     <FaCheck className="check-icon" />
//                     {point}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
    
//     </>
//   );
// };

// export default CareerSection;









import React from "react";
import {
  FaHandshake,
  FaCarSide,
  FaUserTie,
  FaHeadset,
  FaCheck,
} from "react-icons/fa";

const careers = [
  {
    icon: <FaHandshake />,
    title: "Business Partner",
    description:
      "Collaborate with Shivai Tours & Travels and grow your transportation business with our trusted travel network.",
    points: [
      "Fleet Expansion Support",
      "Long-Term Business Growth",
      "High Revenue Opportunities",
    ],
  },
  {
    icon: <FaCarSide />,
    title: "Driver Partner",
    description:
      "Join as a driver partner and earn consistently with flexible schedules and reliable trip bookings.",
    points: [
      "Valid Driving License Required",
      "Commercial Vehicle Preferred",
      "Daily / Weekly Earnings",
    ],
  },
  {
    icon: <FaUserTie />,
    title: "Travel Booking Agent",
    description:
      "Assist customers with bookings, packages, and travel planning as a Shivai Tours & Travels agent.",
    points: [
      "Commission-Based Earnings",
      "Customer Booking Support",
      "Office & Remote Opportunities",
    ],
  },
  {
    icon: <FaHeadset />,
    title: "Customer Support Executive",
    description:
      "Handle customer queries, booking assistance, and operational support professionally.",
    points: [
      "Office-Based Role",
      "Flexible Shift Timings",
      "Career Growth Opportunities",
    ],
  },
];

const CareerSection = () => {
  return (
    <>
      {/* BREADCRUMB */}
      <div className="breadcrumb-bar text-center">
        <h2 className="text-white">Career</h2>
      </div>

      <section className="career-section">
        <div className="container">

          {/* HEADER */}
          <div className="career-header">
            <h2>
              Career At <span>Shivai Travels</span>
            </h2>

            <p>
              Join Shivai Tours & Travels and build a successful career as a
              Partner, Driver, Booking Agent, or Support Executive.
            </p>
          </div>

          {/* CAREER CARDS */}
          <div className="career-grid">
            {careers.map((item, index) => (
              <div className="career-card" key={index}>
                <div className="career-icon">{item.icon}</div>

                <h3>{item.title}</h3>
                <p>{item.description}</p>

                <ul>
                  {item.points.map((point, i) => (
                    <li key={i}>
                      <FaCheck className="check-icon" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* CONTACT + FORM SECTION */}
          <div className="career-contact">

            {/* CONTACT INFO */}
            <div className="contact-info">
              <h3>Contact Details</h3>

              <div className="info-item">
                <span>📞</span>
                <p>+91 9689815477</p>
              </div>

              <div className="info-item">
                <span>📧</span>
                <p>booking@shivaitravels.com</p>
              </div>

              <div className="info-item">
                <span>📍</span>
                <p>
                  Shivai Travels, Shop No 1, Kamdhenu Nagar, Guru Mauli Society,
                  Vadgaon Road, Near Super Bazar, Alandi, Pune - 412105
                </p>
              </div>
            </div>

            {/* WHATSAPP FORM */}
            <div className="contact-form">
              <h3>Apply Now </h3>

              <form
                onSubmit={(e) => {
                  e.preventDefault();

                  const name = e.target.name.value;
                  const email = e.target.email.value;
                  const phone = e.target.phone.value;
                  const role = e.target.role.value;
                  const message = e.target.message.value;

                  const text = `Hello Shivai Travels,%0A
Name: ${name}%0A
Email: ${email}%0A
Phone: ${phone}%0A
Apply For: ${role}%0A
Message: ${message}`;

                  window.open(
                    `https://wa.me/919689815477?text=${text}`,
                    "_blank"
                  );
                }}
              >
                <input name="name" type="text" placeholder="Your Name" required />
                <input name="email" type="email" placeholder="Your Email" required />
                <input name="phone" type="text" placeholder="Phone Number" required />

                <select name="role" required>
                  <option value="">Apply For</option>
                  <option>Business Partner</option>
                  <option>Driver Partner</option>
                  <option>Travel Agent</option>
                  <option>Customer Support</option>
                </select>

                <textarea name="message" placeholder="Your Message" required />

                <button type="submit">Send on WhatsApp</button>
              </form>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default CareerSection;